import { render, staticRenderFns } from "./ClientProspectCard.vue?vue&type=template&id=5123acc2&scoped=true"
import script from "./ClientProspectCard.vue?vue&type=script&lang=js"
export * from "./ClientProspectCard.vue?vue&type=script&lang=js"
import style0 from "./ClientProspectCard.vue?vue&type=style&index=0&id=5123acc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123acc2",
  null
  
)

export default component.exports